module.exports = __webpack_public_path__ + "static/media/weld_wps_1.e5e0ec1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/weld_wps_1.jpg
// module id = 1909
// module chunks = 0